import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import { ExternalLink, Clock,  Mail, Facebook, Linkedin, Instagram, Twitter,X, LogOut as UsersIcon, Phone, MapPin, MessageCircle } from "react-feather";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as faStarEmpty,
  faXTwitter,  
  faLinkedinIn,
  faFacebookF,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";


const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Handle form input changes
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const [nameError, setNameError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      // Allow only letters and spaces, minimum 3 characters
      if (/^[A-Za-z\s]{0,50}$/.test(value)) {
        setFormData({ ...formData, [name]: value });

        // Validate minimum 3 characters
        if (value.length < 3) {
          setNameError("Name must be at least 3 letters long");
        } else {
          setNameError("");
        }
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null); // Reset error state on submit

    try {
      // API call to insert contact form data into the database
      const response = await axios.post(`${BASE_URL}/submit-contact`, formData);

      if (response.data.success) {
        toast.success("Your message has been sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        }); // Reset the form after successful submission
      } else {
        setError("Failed to send message.");
      }
    } catch (err) {
      console.error("Error submitting contact form:", err);
      setError("Failed to send message.");
    } finally {
      setLoading(false);
    }
  };






  return (
    <>
      <NavbarVisitor />

      <div className="container-fluid">
        <div className="row mt-3 justify-content-center mb-5">
          

          <div className="col-md-8 text-start">
            <div className="eventcard_container bdrds p-3">
              <h2 className="text-center mb-4">Contact Us!</h2>
              <div className="text-center mb-4">
                We’d love to hear from you. Get in touch to brainstorm how we
                can support your movement building and member engagement
                efforts.
              </div>

              {error && <div className="alert alert-danger">{error}</div>}

              <div className="d-flex justify-content-center">
                {" "}
                {/* Flexbox wrapper to center the form */}
                <form
                  onSubmit={handleSubmit}
                  className="form-contact maxwidcont"
                >
                  <div className="row">
                  <div className="mb-2 col-md-6">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
        type="text"
        className="input-class"
        id="name"
        name="name"
        placeholder="Enter Name Here"
        value={formData.name}
        onChange={handleChange}
        required
      />
      {nameError && <p style={{ color: "red" }}>{nameError}</p>}

                  </div>

                  <div className="mb-2 col-md-6">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="input-class"
                      id="email"
                      name="email"  placeholder="Enter Email Here"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-2">
  <label htmlFor="phone" className="form-label">Mobile Number</label>
  <div className="d-flex">
    {/* Country Code Dropdown */}
    <select
      className="input-class me-2"
      id="countryCode"
      value={formData.countryCode}
      onChange={(e) => handleChange({ target: { name: "countryCode", value: e.target.value } })}
    >
      <option value="+91">🇮🇳 +91 (India)</option>
      <option value="+1">🇺🇸 +1 (USA)</option> 
      <option value="+44">🇬🇧 +44 (UK)</option>
      <option value="+61">🇦🇺 +61 (Australia)</option>
      <option value="+81">🇯🇵 +81 (Japan)</option>
      {/* Add more countries as needed */}
    </select>

    {/* Phone Number Input */}
    <input
      type="tel"
      className="input-class"
      id="phone"
      name="phone"
      placeholder="Enter Phone Here"
      value={formData.phone}
      onChange={(e) => {
        const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        if (value.length <= 10) {
          handleChange({ target: { name: "phone", value } });
        }
      }}
      pattern="\d{10}"
      maxLength="10"
      title="Phone number must be exactly 10 digits"
      required
    />
  </div>
</div>


                  <div className="mb-2">
                    <label htmlFor="subject" className="form-label">
                      Subject
                    </label>
                    <input
                      type="text"
                      className="input-class"
                      id="subject"
                      name="subject"  placeholder="Enter Subject Here"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-2">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      className="textarea-class"
                      id="message"
                      name="message"
                      rows="4"  placeholder="Enter Message Here"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <div className="text-end">
                    <button className="btnsubmit" disabled={loading}>
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                  </div>
                  
                </form>
              </div>
            </div>
          </div>


          <div className="col-md-4 text-start">
            <div className="bgnk rounded">
              <div className="row p-4">
                <div className="col-12 mb-4">
                  <Mail className="ic" size={40} />
                  <p>
                    We’re here to help you make the most out of Eventoz
                    Platform. Whether you have questions, need support, or
                    simply want to share your feedback, feel free to reach out
                    to us.
                  </p>
                </div>

                <div className="col-12">

                <h6><strong>Connect us at </strong></h6>
                <div className="mb-2">
  <Mail className="ic" size={20} />{" "}
  <a href="mailto:info@evventoz.com"><strong>info@evventoz.com</strong></a>
</div>


<div className="mb-2"> 
  <FontAwesomeIcon icon={faWhatsapp} size={30} className="text-dark" style={{height: '20px'}} />{" "}
  <a href="tel:+918080243455"><strong>80802 43455</strong></a>
</div>

<div className="mb-2">
  <MapPin className="ic" size={20} />{" "}
  <a href="#"><strong>S.No. 7/11, Viman Nagar, Pune</strong></a>
</div>

                  
                  <h6><strong>Connect with Us Online</strong></h6>

                  <div>
                  <div className="mb-2">
                  <Facebook className="ic" size={20} />{" "}
                    <a href="https://www.facebook.com/profile.php?id=61560048915788" target="_blank">Facebook</a>
                  </div>

                  <div className="mb-2">
                  <Instagram className="ic" size={20} />{" "}
                    <a href="https://www.instagram.com/evventoz/" target="_blank">Instagram</a>
                  </div>

                  <div className="mb-2"> 
                  <FontAwesomeIcon icon={faXTwitter} size={20} className="text-dark" />{" "}
                    <a href="https://x.com/evventoz" target="_blank">Twitter X</a>
                  </div>

                  <div className="mb-2"> 
                  <Linkedin size={20}  />{" "}
                    <a href="https://www.linkedin.com/company/evventoz/" target="_blank">Linkedin</a>
                  </div>


                  </div>
                   
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default Contact;
